/**
 * useScreenTracking — sets the "current page" attached to every analytics
 * event enqueued from now on. Call it once per customer page component:
 *
 *     function CouponDetailsPage() {
 *       useScreenTracking('CouponDetails');
 *       ...
 *     }
 *
 * Deliberately does NOT clear the screen name on unmount — same as the
 * mobile version, an event enqueued during the brief unmount/mount gap
 * between two pages should still carry the outgoing page's name rather
 * than null.
 *
 * If you want the name to react to dynamic route params (e.g. include a
 * coupon slug), just build the string before passing it in — the hook
 * re-applies it whenever the value you pass changes:
 *
 *     useScreenTracking(`CouponDetails:${couponId}`);
 */
import { useEffect } from 'react';
import { setCurrentScreen } from './analytics';

export function useScreenTracking(screenName) {
  useEffect(() => {
    setCurrentScreen(screenName);
  }, [screenName]);
}